import { render, staticRenderFns } from "./SourceInquiryList.vue?vue&type=template&id=a5c6706c&scoped=true"
import script from "./SourceInquiryList.vue?vue&type=script&lang=js"
export * from "./SourceInquiryList.vue?vue&type=script&lang=js"
import style0 from "./SourceInquiryList.vue?vue&type=style&index=0&id=a5c6706c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c6706c",
  null
  
)

export default component.exports